import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantEditIncomePage = {
  alert: {
    error: 'coapplicant-edit-income-page.form.alert.error',
  },
  footer: {
    root: 'coapplicant-edit-income-page.footer.root',
  },
  form: {
    amountInput: 'coapplicant-edit-income-page.form.amount-input',
    amountInputError: 'coapplicant-edit-income-page.form.amount-input-error',
    cancelButton: 'coapplicant-edit-income-page.form.cancel-button',
    employerNameInput: 'coapplicant-edit-income-page.form.employer-name-input',
    employerNameInputError:
      'coapplicant-edit-income-page.form.employer-name-input-error',
    frequencySelect: 'coapplicant-edit-income-page.form.frequency-select',
    frequencySelectError:
      'coapplicant-edit-income-page.form.frequency-select-error',
    h1: 'coapplicant-edit-income-page.form.h1',
    h2: 'coapplicant-edit-income-page.form.h2',
    hasAdditionalIncomeSelect:
      'coapplicant-edit-income-page.form.has-additional-income-select',
    hasAdditionalIncomeSelectError:
      'coapplicant-edit-income-page.form.has-additional-income-select-error',
    incomeTypeSelect: 'coapplicant-edit-income-page.form.income-type-select',
    incomeTypeSelectError:
      'coapplicant-edit-income-page.form.income-type-select-error',
    jobTitleInput: 'coapplicant-edit-income-page.form.job-title-input',
    jobTitleInputError:
      'coapplicant-edit-income-page.form.job-title-input-error',
    monthSelect: 'coapplicant-edit-income-page.form.month-select',
    monthSelectError: 'coapplicant-edit-income-page.form.month-select-error',
    root: 'coapplicant-edit-income-page.form.root',
    submitButton: 'coapplicant-edit-income-page.form.submit-button',
    yearSelect: 'coapplicant-edit-income-page.form.year-select',
    yearSelectError: 'coapplicant-edit-income-page.form.year-select-error',
  },
  header: {
    drawerButton: 'coapplicant-edit-income-page.header.drawer-button',
    previousStepButton:
      'coapplicant-edit-income-page.header.previous-step-button',
    root: 'coapplicant-edit-income-page.header.root',
  },
  progress: {
    root: 'coapplicant-edit-income-page.progress.root',
  },
} as const satisfies PageLocatorMap;
